module.exports = __webpack_public_path__ + "img/TDC-L2-8-Pagina8 B.728c521a.png";